// extracted by mini-css-extract-plugin
export default {"NumberChart":"_NumberChart--Wb9uy","Number":"_Number--fNBUn","TitleWrapper":"_TitleWrapper--mCZZr","Title":"_Title--uRxvX","ChartButton":"_ChartButton--qiD5O"};